import clsx from "clsx";
import React from "react";
import { useIntercom } from "src/hooks";
import type { NavBarSection } from "../SharedLayout/NavBar";
import TopBar, { type TopBarProps } from "../SharedLayout/TopBar";
import { useSideMenuLayoutStyles } from "./SideMenuLayout.styles";

interface SideMenuLayoutProps {
    sections?: NavBarSection[];
    isAdmin?: boolean;
    children?: React.ReactNode;
    topBarProps?: TopBarProps;
    className?: string;
    classNameMenu?: string;
}

export function SideMenuLayout({
    sections,
    isAdmin,
    children,
    topBarProps = {},
    className,
    classNameMenu,
}: SideMenuLayoutProps): JSX.Element {
    const classes = useSideMenuLayoutStyles();

    if (!isAdmin) {
        useIntercom();
    }

    const childrenArray = React.Children.toArray(children);

    const [menu, content] = childrenArray.length > 1 ? childrenArray : [null, childrenArray[0]];

    return (
        <div className={clsx(classes.root, className)}>
            <TopBar {...topBarProps} />
            <div className={classes.content}>
                <div className={clsx({ [classes.withSection]: Boolean(sections) })}>
                    {sections && (
                        <div className={clsx(classes.menuContainer, classNameMenu)}>{menu}</div>
                    )}
                    <div className={classes.contentContainer}>{content}</div>
                </div>
            </div>
        </div>
    );
}
